import axios from "axios";
import authHeader from "../../api/services/token.interceptor";
const API_URL= process.env.REACT_APP_API_URL;
export const getCart =async (id) =>
    await axios.get(API_URL+`/recouv/cart/?user=${id}&is_status=true` ,{
        headers: authHeader(),
    })
